const sessionFallback = new Set<string>();

const storageKey = (userId: string, tourId: string) =>
  `karda-investigator-tour:${encodeURIComponent(userId)}:${encodeURIComponent(tourId)}`;

export function hasSeenPageTour(userId: string, tourId: string): boolean {
  const key = storageKey(userId, tourId);
  if (sessionFallback.has(key)) return true;
  try {
    return window.localStorage.getItem(key) === "seen";
  } catch {
    return false;
  }
}

export function markPageTourSeen(userId: string, tourId: string) {
  const key = storageKey(userId, tourId);
  try {
    window.localStorage.setItem(key, "seen");
  } catch {
    // Keep Skip/Finish effective for this session if browser storage is blocked.
    sessionFallback.add(key);
  }
}
